'use client';

import { Button, Heading, Text, VStack } from '@jaaq/hub-ui';
import { logger } from '@jaaq/observability';
import { type ReactElement, useEffect } from 'react';

type ErrorPageProps = {
  error: Error & { digest?: string };
  unstable_retry: () => void;
};

const ErrorPage = ({ error, unstable_retry }: ErrorPageProps): ReactElement => {
  useEffect(() => {
    logger.error('app/error: route segment failed', { error, digest: error.digest });
  }, [error]);

  return (
    <VStack align="center" justify="center" gap={4} className="min-h-[60vh] p-8 text-center">
      <Heading level={1} variant="subtitle" tone="inverse">
        Something went wrong
      </Heading>
      <Text muted tone="inverse" className="max-w-md">
        We hit an unexpected error loading this page. Try again, or refresh the browser if the issue
        persists.
      </Text>
      <Button variant="filled" size="regular" onClick={() => unstable_retry()}>
        Try again
      </Button>
    </VStack>
  );
};

export default ErrorPage;
